import { render, staticRenderFns } from "./TaskStatusTag.vue?vue&type=template&id=66417748&scoped=true&"
import script from "./TaskStatusTag.vue?vue&type=script&lang=ts&"
export * from "./TaskStatusTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66417748",
  null
  
)

export default component.exports